export enum SignoutReason {
  DEFAULT = 'default',
  INACTIVE = 'inactive',
  SIGNOUT_REMOTE = 'AccessTokenRevokedError',
}
